import styled from 'styled-components/macro';
import { DefaultIcon } from '../Icon';

export const SwitchSpan = styled.span`
  display: inline-grid;
  > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;

    > p {
      font-family: canada-type-gibson, helvetica, sans-serif;
      font-weight: 600;
    }
    > span {
      display: flex;
      flex-direction: column;
      padding-left: 6px;
    }
  }
`;

export const SwitchIcon = styled(DefaultIcon)`
  fill: ${props => props.theme[props.fill]};
  width: 7.5px;
  height: 6.5px;
`;
